<div class="collapse" [ngbCollapse]="collapse_skills" id="dateposted-11">
  <div class="bg-light p-3 mt-4">
    <form [formGroup]="form">
      <div class="form-row align-items-center" *ngFor="let skill of dashboardState.skills | async; let i = index">
        <div class="form-group col-md-6">
          <label>Title</label>
          <input type="text" class="form-control" placeholder="Photoshop" value="{{skill.title}}"
            (input)="skill.title = $event.target.value">
        </div>
        <div class="form-group col-md-5">
          <label>Proficiency</label>
          <input type="text" class="form-control" placeholder="70%" value="{{skill.level}}"
            (input)="skill.level= $event.target.value">
        </div>
        <div class=" col-md-1 d-flex align-items-center justify-content-end">
          <ul class="list-unstyled d-flex">
            <li>
              <a class="text-right" data-toggle="collapse" [routerLink]="" (click)="save()" role="button" aria-expanded="false"
              aria-controls="dateposted"> <i class="far fa-save text-info mr-3"></i> </a>
            </li>
            <li>
              <a [routerLink]="" role="button" (click)="remove(i)"><i class="far fa-trash-alt text-danger"></i></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="form-row align-items-center margin-left-5">
        <a class="btn btn-md btn-primary" [routerLink]="" (click)="add()">Add More</a>
      </div>
    </form>
  </div>
</div>
